import { colors } from '../../Colors/colors'

export const commonTheme = {
   light: {
      assigneeUpdatePushNotificationCard: {
         arrowIconColor: colors['primary-600'],
         cardBorderColor: 'border-gray-100',
         closeIconColor: colors['gray-500'],
         descriptionTextColor: 'text-gray-600',
         notificationPrefixIconBGColor: 'bg-primary-100',
         notificationPrefixIconBorderColor: 'border-primary-50',
         notificationPrefixIconColor: colors['primary-600'],
         titleTextColor: 'text-gray-900'
      },
      cardWithMark: {
         markBgColor: 'bg-primary-600',
         whiteBgColor: 'bg-white',
         borderColor: 'border-gray-300'
      },
      modalCloseButton: {
         closeIconFillColor: colors['gray-700'],
         buttonBgBlurHoverColor: 'hover:bg-[#00000025]',
         buttonBgBlurColor: 'bg-[#00000010]'
      },
      pipelinesPopover: {
         bodyBorder: 'border-gray-200',
         bodyBg: 'bg-base-white',
         headerTextColor: 'text-gray-900',
         headerBorderColor: 'border-gray-200',
         noDataViewText: 'text-gray-700',
         pipelineItem: {
            hoverBgColor: 'hover:bg-gray-50',
            textColor: 'text-gray-900'
         }
      },
      toastUtils: {
         refreshButtonRetryIconColor: colors['error-700']
      },
      whatsAppBgColor: 'bg-success-50',
      borderColor: 'border-gray-300',
      defaultHoverBgColor: 'hover:bg-gray-50',
      transparentBgColor: 'bg-[transparent]',
      skeletonLoaderBaseColor: colors['gray-300'],
      skeletonLoaderHighlightColor: '#EDF3F6',
      defaultModalDescriptionTextColor: 'text-gray-900',
      confirmationUI: {
         closeIconColor: colors['gray-500'],
         headingColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         xCloseHoverColor: 'hover:bg-gray-50'
      },
      deleteCard: {
         backgroundColor: 'bg-base-white',
         boardHeading: 'text-gray-900',
         description: 'text-gray-600',
         closeIconColor: colors['gray-500']
      },
      collapsibleCard: {
         cardHeadingTextColor: 'text-gray-800',
         chevronIconColor: colors['gray-500'],
         cardBgColor: 'bg-base-white'
      },
      sidePane: {
         borderColor: 'border-gray-200',
         backgroundColor: 'bg-base-white'
      },
      remarks: {
         selectedCardBorder: 'border-primary-300',
         documentAttachmentIconStrokeColor: colors['primary-600'],
         documentAttachmentIconFillColor: colors['blue-50'],
         documentTitleTextColor: 'text-gray-700',
         documentTypeTextColor: 'text-gray-500',
         outlineChevronIconColor: colors['base-white'],
         actionItemHoverColor: 'hover:bg-gray-50',
         actionItemTextColor: 'text-gray-700',
         actionItemBgColor: 'bg-gray-50',
         dividerColor: 'bg-blue-gray-200',
         playBackSpeedTextColor: 'text-gray-50',
         playBackSpeedBgColor: 'bg-gray-500',
         audioRemarkBorderColor: 'border-gray-300',
         headPhoneIconFillColor: colors['orange-600'],
         headPhoneIconStrokeColor: colors['orange-600']
      },
      audioPlayer: {
         playIconColor: colors['primary-600'],
         pauseIconColor: colors['primary-600']
      },
      userAsyncComboBox: {
         customOption: {
            customOptionLabelColor: 'text-gray-900',
            checkIconColor: colors['primary-600'],
            disabledCustomOptionBgColor: 'bg-gray-25',
            disabledCustomOptionTextColor: 'text-gray-300',
            customOptionFocusBgColor: 'bg-gray-50',
            customOptionHoverBgColor: 'hover:bg-gray-50'
         }
      },
      pushToEntityPipeline: {
         ChevronLeftIconColor: colors['primary-600'],
         noAssigneesBorder: 'border-primary-300',
         infoCircleIconColor: colors['primary-600'],
         noAssigneeTextColor: 'text-primary-700',
         noAssigneesBgColor: 'bg-primary-25',
         notificationToggleTextColor: 'text-gray-600'
      },
      valueSource: {
         valueSourceTextColor: 'text-gray-900',
         valueSourceTextDisabledColor: 'text-gray-500',
         background: 'bg-base-white',
         disabledBackground: 'bg-gray-50',
         borderColor: 'border-gray-300 '
      },
      sectionAsyncComboBox: {
         tickMarkColor: colors['primary-600'],
         inputTextColor: 'text-gray-900',
         customOptionHoverColor: 'hover:bg-gray-50',
         customOptionBgColor: 'bg-gray-50',
         customOptionTextColor: 'text-gray-700',
         searchIconFillColor: colors['gray-500'],
         customOptionSupportTextColor: 'text-gray-500'
      },
      fileUploader: {
         inputHandlerBorderColor: 'border-gray-300',
         clickToUploadTextColor: 'text-primary-600',
         acceptedFileTypesTextColor: 'text-gray-600',
         failureCardBgColor: 'bg-error-25',
         failureCardBorderColor: `border-error-300`,
         failureCardNameTextColor: 'text-error-700',
         failureCardSizeTextColor: 'text-error-600',
         failureCardIconColor: colors['error-700'],
         cardBorderColor: 'border-gray-300',
         slimNameTextColor: 'text-gray-700',
         nameTextColor: 'text-gray-600',
         sizeTextColor: 'text-gray-600',
         dividerBgColor: 'bg-gray-200',
         attachmentIconColor: colors['primary-600']
      },
      multiStageTagAsyncComboBox: {
         labelColor: 'text-gray-700',
         plusIconColor: colors['primary-600'],
         closeIconColor: colors['gray-500']
      },
      multiRolesTagAsyncComboBox: {
         labelColor: 'text-gray-700',
         plusIconColor: colors['primary-600'],
         closeIconColor: colors['gray-500']
      },
      multiOptionsTagComboBox: {
         labelColor: 'text-gray-700',
         closeIconColor: colors['gray-500'],
         badgeBorderColor: 'border-gray-300'
      },
      multiActivitiesTagAsyncComboBox: {
         labelColor: 'text-gray-700',
         closeIconColor: colors['gray-500'],
         badgeBorderColor: 'border-gray-300'
      },
      colorPicker: {
         textColor: 'text-gray-900',
         selectedBorderColor: 'border-primary-600',
         hoveredBorderColor: 'border-gray-300',
         focusRingColor: 'ring-gray-100',
         colors: {
            BLUE: 'bg-blue-600',
            BLUE_DARK: 'bg-blue-dark-600',
            BLUE_LIGHT: 'bg-blue-light-600',
            CYAN: 'bg-cyan-600',
            FUCHSIA: 'bg-fuchsia-600',
            GREEN: 'bg-green-600',
            GREEN_LIGHT: 'bg-green-light-600',
            INDIGO: 'bg-indigo-600',
            MOSS: 'bg-moss-600',
            ORANGE: 'bg-orange-600',
            ORANGE_DARK: 'bg-orange-dark-600',
            PINK: 'bg-pink-600',
            PURPLE: 'bg-purple-600',
            ROSE: 'bg-rose-600',
            TEAL: 'bg-teal-600',
            VIOLET: 'bg-violet-600',
            YELLOW: 'bg-yellow-600'
         },
         trigger: {
            borderColor: 'border-gray-300',
            bgColor: 'bg-base-white'
         }
      },
      pipelinePicker: {
         tickIconColor: colors['primary-600'],
         customOptionHoverBgColor: 'hover:bg-gray-50',
         selectedPipelineBGColor: 'bg-primary-50'
      },
      whatsappIntegrations: {
         sidePaneHeader: {
            navigateButtonIconFillColor: colors['primary-600'],
            closeIconFillColor: colors['gray-500'],
            borderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900'
         },
         messageTemplates: {
            templateTextColor: 'text-gray-700',
            copyIconColor: colors['primary-600'],
            eyeIconColor: colors['primary-600'],
            cardBorderColor: 'border-gray-300',
            templateNameColor: 'text-gray-700',
            templateContentColor: 'text-gray-500',
            dividerBgColor: 'bg-gray-300'
         },
         selectedNumbers: {
            labelTextColor: 'text-gray-600',
            sectionCard: {
               sectionNameTextColor: 'text-gray-700',
               sectionDescriptionTextColor: 'text-gray-500',
               sectionCardBGColor: 'bg-primary-50',
               sectionCardBorderColor: 'border-primary-600',
               headerTextColor: 'text-gray-900',
               descriptionTextColor: 'text-gray-600',
               closeIconColor: colors['gray-500'],
               defaultBorderColor: 'border-gray-200',
               selectedSectionTextColor: 'text-primary-800',
               selectedSectionDescriptionTextColor: 'text-primary-700',
               selectedSectionRadioBorderColor: colors['primary-300'],
               selectedSectionRadioDotColor: colors['primary-600'],
               selectedSectionRadioBGColor: 'bg-primary-100',
               unSelectedSectionRadioBorderColor: colors['gray-300'],
               unSelectedSectionRadioBGColor: 'bg-gray-100'
            },
            warningCard: {
               bgColor: 'bg-warning-25',
               alertIconFillColor: colors['warning-600'],
               textColor: 'text-warning-700',
               borderColor: 'border-warning-500'
            }
         }
      },
      shareableResources: {
         title: 'text-gray-700',
         description: 'text-gray-500',
         openIconFill: colors['gray-500'],
         border: 'border-gray-300',
         whatsAppButtonBgColor: 'bg-success-50',
         whatsAppButtonTextColor: 'text-success-600',
         rightArrowIconColor: colors['base-white'],
         footerBorderColor: 'border-gray-300'
      },
      draftEditorJS: {
         defaultTextColor: 'text-gray-700',
         defaultBorderColor: 'border-gray-300',
         richTextColor: 'text-primary-600',
         defaultDescriptionColor: 'text-gray-700',
         defaultErrorTextColor: 'text-error-500',
         whatsAppButtonTextColor: 'text-success-600',
         rightArrowIconColor: colors['base-white'],
         footerBorderColor: 'border-gray-300',
         defaultReadOnlyTextColor: 'text-gray-600'
      },
      messageTemplate: {
         defaultHeaderTextColor: 'text-gray-800',
         defaultBorderColor: 'border-gray-300',
         mediaNameTextColor: 'text-gray-700',
         documentNameTextColor: 'text-gray-400'
      },
      iconPicker: {
         colors: {
            BLUE: colors['blue-600'],
            BLUE_DARK: colors['blue-dark-600'],
            BLUE_LIGHT: colors['blue-light-600'],
            CYAN: colors['cyan-600'],
            FUCHSIA: colors['fuchsia-600'],
            GREEN: colors['green-600'],
            GREEN_LIGHT: colors['green-light-600'],
            INDIGO: colors['indigo-600'],
            MOSS: colors['moss-600'],
            ORANGE: colors['orange-600'],
            ORANGE_DARK: colors['orange-dark-600'],
            PINK: colors['pink-600'],
            PURPLE: colors['purple-600'],
            ROSE: colors['rose-600'],
            TEAL: colors['teal-600'],
            VIOLET: colors['violet-600'],
            YELLOW: colors['yellow-600']
         },
         selectedIconBorderColor: 'border-primary-600',
         trigger: {
            borderColor: 'border-gray-300',
            bgColor: 'bg-base-white'
         },
         selectedBorderColor: 'border-primary-600',
         hoveredBorderColor: 'border-gray-300',
         focusRingColor: 'ring-gray-100',
         defaultIconColor: colors['gray-600'],
         iconHoverColor: 'bg-gray-100',
         titleTextColor: 'text-gray-500',
         popoverBgColor: 'bg-base-white'
      },
      pipelineItemAsyncComboBox: {
         customOption: {
            customOptionLabelColor: 'text-gray-900',
            customOptionSubTextColor: 'text-gray-600',
            checkIconColor: colors['primary-600'],
            disabledCustomOptionBgColor: 'bg-gray-25',
            disabledCustomOptionTextColor: 'text-gray-300',
            customOptionFocusBgColor: 'bg-gray-50',
            customOptionHoverBgColor: 'hover:bg-gray-50'
         }
      },
      filePreviewCarousel: {
         defaultIconColor: colors['base-white'],
         titleColor: 'text-gray-900',
         disabledNavigationIconColor: colors['gray-400'],
         closeIconStrokeColor: colors['gray-600'],
         filePreviewFooter: {
            defaultBgColor: 'bg-gray-800',
            filePositionTextColor: 'text-base-white',
            fileNameColor: 'text-gray-300',
            defaultButtonTextColor: 'text-base-white',
            documentTemplateBgColor: 'bg-base-white',
            navigationButtonTheme: {
               bgColor: 'bg-gray-700',
               textColor: 'text-gray-200',
               borderColor: 'border-gray-500',
               iconColor: colors['gray-200'],
               buttonRingColor: 'ring-gray-600'
            }
         },
         audioPreviewBgColor: 'bg-base-white'
      },
      fileUploaderField: {
         defaultBorderColor: 'border-gray-300',
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-600',
         uploadedFilesCountTextColor: 'text-gray-700',
         maxLimitReachedColor: 'text-gray-600',
         uploadedFilesActions: {
            defaultActionIconColor: colors['gray-500'],
            labelColors: 'text-gray-900',
            sectionDividerColors: 'bg-gray-300 border-gray-300',
            actionsHoverBgColor: 'hover:bg-gray-50'
         },
         addAttachment: {
            iconColor: colors['primary-600'],
            textColor: 'text-primary-600',
            textDisabledColor: 'text-gray-300',
            iconDisabledColor: colors['gray-300'],
            lineBgColor: 'bg-gray-200'
         },
         fileInfo: {
            fileNameColor: 'text-gray-600'
         },
         moreFiles: {
            fileBottomBorderColor: 'border-gray-200',
            moreBorderColor: 'border-gray-300',
            moreHoverBgColor: 'hover:bg-gray-50',
            moreTextColor: 'text-gray-800'
         }
      },
      carousel: {
         defaultIconColor: colors['base-white'],
         disabledNavigationIconColor: colors['gray-400']
      },
      uploadedFilesList: {
         uploadedFileTextColor: 'text-gray-700',
         uploadedFileListTypeTextColor: 'text-primary-600',
         uploadedFileListTypeIconColor: colors['primary-600'],
         uploadedFileIconColor: colors['gray-700'],
         defaultBorderColor: 'border-gray-300'
      },
      recordsSearch: {
         labelTextColor: 'text-gray-700',
         errorMessageTextColor: 'text-error-500',
         borderColor: 'border-gray-300',
         errorBorderColor: 'border-error-300',
         focusedBorderColor: 'border-primary-300',
         focusedRingColor: 'ring-primary-100',
         trigger: {
            tagsNameTextColor: 'text-gray-700',
            placeholderTextColor: 'text-gray-500'
         },
         results: {
            nameTextColor: 'text-gray-700',
            navigateIconHoverColor: 'bg-gray-200'
         }
      },
      labelMultiSelect: {
         selectedBgColor: 'bg-gray-50',
         closeIconColor: colors['gray-500'],
         tooltipBgColor: 'bg-gray-900',
         tickIconColor: colors['primary-600'],
         countTextColor: 'text-gray-900'
      },
      labelPicker: {
         tickIconColor: colors['primary-600'],
         hoverOptionStyles: 'bg-gray-100',
         placeHolderTextColor: 'text-gray-500'
      },
      singleFileUploader: {
         defaultIconColor: colors['base-white'],
         closeIconStrokeColor: colors['gray-600'],
         errorBorderStyles: '!border-error-300',
         errorTextColor: 'text-error-600'
      },
      pipelineItemStageField: {
         customOptionHoverBgColor: 'hover:bg-gray-50',
         focusBgColor: 'bg-gray-50',
         selectedBgColor: 'bg-gray-50',
         customOptionTextColor: 'text-gray-900',
         customBadgeTextColor: 'text-gray-700',
         checkIconColor: colors['primary-600'],
         badgeBorderColor: 'border-gray-300',
         badgeCloseIconColor: colors['gray-400']
      },
      simpleActionsMenu: {
         textColor: 'text-gray-800',
         hoverBgColor: 'hover:bg-gray-50'
      },
      otpVerification: {
         headingColor: 'text-gray-900',
         labelColor: 'text-gray-500',
         valueColor: 'text-gray-700',
         otpTimerTextColor: 'text-gray-600',
         disabledOtpTimerTextColor: 'text-gray-300',
         resendOTPActiveTextColor: 'text-blue-600',
         resendOTPDisabledTextColor: 'text-gray-300',
         otpInputBGColor: 'bg-white',
         otpInputDisabledBorderColor: 'border-gray-300',
         otpInputTextColor: 'text-primary-600',
         otpInputFocusBGColor: 'bg-white',
         otpInputFocusBorderColor: 'focus:border-primary-600',
         otpInputErrorBorderColor: '!border-error-300',
         otpErrorInputTextColor: '!text-error-700'
      },
      chatBox: {
         headerTextColor: 'text-gray-700',
         descriptionTextColor: 'text-gray-600',
         chatBoxTextField: {
            chatBoxTextColor: '!text-gray-700',
            defaultBgColor: 'bg-base-white',
            descriptionTextColor: 'text-gray-500',
            descriptionLinkTextUnderLineColor: 'decoration-gray-500',
            inputFocusedBorderColor: 'border-primary-600',
            inputBorderColor: 'border-gray-300',
            iconButtonBgColor: '!bg-gray-50',
            sendIconButtonColor:
               'bg-[linear-gradient(90deg,_#1570EF_0%,_#2E90FA_100%)]'
         },
         chatHistoryCard: {
            headerTextColor: 'text-gray-600',
            historyTitleColor: 'text-gray-800',
            historyDateTimeTextColor: 'text-gray-500'
         }
      },
      userQueriedChatBox: {
         cardBorderColor: 'border-gray-300',
         activeCardBorderColor: 'border-primary-600',
         dotBgColor: 'bg-gray-300',
         nameTextColor: 'text-gray-600',
         timeTextColor: 'text-gray-400',
         editButtonTextColor: 'text-gray-700',
         userSearchQueryTextColor: '!text-gray-700',
         defaultBgColor: 'bg-base-white',
         messageContentTextColor: 'text-gray-700'
      },
      sqlQueryCard: {
         clausesTextColor: 'text-primary-600',
         operatorsTextColor: 'text-orange-600',
         defaultTextColor: 'text-gray-600',
         normalTextColor: 'text-teal-600',
         sqlQueryBgColor: 'bg-gray-50'
      },
      chatSupportHistoryPopover: {
         refreshIconColor: colors['gray-600'],
         popoverCardBorderColor: 'border-gray-300',
         historyItemHoverColor: 'hover:bg-gray-50',
         historyTextColor: 'text-gray-700',
         historyItemTextColor: 'text-gray-900',
         defaultBgColor: 'bg-base-white'
      },
      goToTop: {
         buttonBgColor: 'bg-gray-800',
         buttonHoverColor: 'hover:bg-gray-900'
      },
      pipelineRedirectionBadge: {
         badgeBorderColor: 'border-gray-200',
         badgeHoverColor: 'hover:bg-gray-50',
         linkExternalColor: colors['gray-600'],
         pipelineTextColor: 'text-gray-700'
      },
      recordPipelineSelection: {
         sectionDividerColors: 'border-gray-300 bg-gray-300',
         titleColors: 'text-gray-900',
         pipelinesHeaderColor: 'text-gray-700',
         pipelinesDescriptionColor: 'text-gray-500',
         loaderIconColor: colors['gray-600'],
         cardBorderColor: 'border-gray-200'
      },
      syncAssignees: {
         toggleBgColor: colors['gray-100'],
         labelTextColor: 'text-gray-700',
         defaultBorderColor: 'border-gray-300',
         titleTextColor: 'text-gray-900',
         descriptionTextColor: 'text-gray-600',
         alertCircleIconColor: colors['warning-600'],
         alertCircleIconContainerColor: 'bg-warning-100',
         alertSecondaryCircleIconContainerColor: 'bg-warning-50',
         usersContainerColors: 'bg-gray-50 border-gray-300',
         errorInfoTextColor: 'text-error-700'
      },
      userDetailsUpdatePushNotificationCard: {
         cardBorderColor: 'border-gray-100',
         cardBgColor: 'bg-base-white',
         descriptionTextColor: 'text-gray-600',
         headerTextColor: 'text-gray-900'
      },
      pipelinePopover: {
         chevronDownIconColor: colors['gray-500'],
         tickIconColor: colors['gray-500'],
         customOptionHoverBgColor: 'hover:bg-gray-50',
         selectedPipelineBGColor: 'bg-primary-50',
         labelClassName: 'text-gray-500',
         borderColor: 'border-gray-300',
         ringOffsetColor: 'ring-offset-0',
         ringColor: 'ring-primary-100'
      },
      markdownFieldEditAndPreview: {
         tabsBgColor: 'bg-base-white',
         tabsBorderColor: 'border-gray-300',
         tabBorderColor: 'border-transparent',
         selectedTabBorderColor: 'border-primary-50',
         boxBorderColor: 'border-gray-300',
         focusedBoxBorderColor: 'border-primary-600',
         tabTextColor: 'text-primary-600',
         selectedTabBgColor: 'bg-primary-50'
      },
      reactQuillTextEditor: {
         defaultBorderColor: 'border-gray-300',
         errorBorderColor: 'border-error-300',
         focusBorderColor: 'border-primary-300',
         defaultTextColor: 'text-gray-700',
         disabledBgColor: 'bg-gray-50',
         cardBgColor: 'bg-base-white'
      },

      aiChatSupport: {
         whiteBgColor: 'bg-white',
         blackBgColor: 'bg-black',
         whiteTextColor: 'text-white',
         headerTitleColor: 'text-gray-700',
         defaultBorderColor: 'border-gray-300',
         chevronIconColor: colors['gray-600'],
         maximizeIconColor: colors['gray-700'],
         messageIconColor: colors['base-white']
      },
      circularProgressBar: {
         emptyIconFillColor: colors['blue-gray-200'],
         successIconFillColor: colors['light-green-500']
      },
      shortfallCounter: {
         shortfallCountColor: 'text-orange-600',
         shortfallZeroCountColor: 'text-gray-600',
         progressBarFillColor: colors['orange-dark-500'],
         progressBarPathColor: colors['gray-300'],
         infoCircleIconColor: colors['gray-600'],
         valueTextColor: 'text-gray-800',
         labelTextColor: 'text-gray-500',
         buttonTextColor: 'text-gray-700',
         disabledButtonTextColor: 'text-gray-400',
         shortFallLimitReached: {
            bgColor: '!bg-gray-900',
            limitTextColor: 'text-gray-200',
            titleColor: 'text-base-white',
            descriptionColor: 'text-gray-300'
         }
      },
      notificationCard: {
         defaultHeaderTextColor: 'text-gray-900',
         defaultDescriptionTextColor: 'text-gray-600'
      },
      slaModal: {
         clockFeaturedIconTheme: {
            fill: colors['warning-100'],
            stroke: colors['warning-50'],
            secondStroke: colors['warning-600']
         },
         headerTheme: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            borderColor: 'border-gray-300'
         },
         bodyTheme: {
            borderColor: 'border-gray-300',
            taskTextColor: 'text-gray-500',
            errorTaskTextColor: 'text-error-600',
            officerNameColor: 'text-gray-700',
            calenderIconTheme: {
               fill: colors['cyan-500'],
               stroke: colors['cyan-600']
            },
            dueDateColor: 'text-gray-900',
            timeTextColor: 'text-gray-900',
            taskLabelColor: 'text-gray-500',
            clockIconTheme: {
               cyan: {
                  fill: colors['cyan-500'],
                  stroke: colors['cyan-600']
               },
               error: {
                  fill: colors['error-500'],
                  stroke: colors['error-600']
               }
            }
         },
         slaDaysCountButtonTheme: {
            skeletonBaseColor: '#00000010',
            skeletonHighlightColor: '#00000019',
            dangerTheme: {
               iconColor: colors['error-600'],
               textColor: '!text-error-700',
               bgColor: 'bg-[#D92D201A]',
               hoverBgColor: 'hover:bg-[#D92D2030]'
            },
            normalTheme: {
               iconColor: colors['gray-700'],
               textColor: '!text-gray-700',
               bgColor: 'bg-[#00000010]',
               hoverBgColor: 'hover:bg-[#00000025]'
            },
            warningTheme: {
               iconColor: colors['warning-700'],
               textColor: '!text-warning-700',
               bgColor: 'bg-[#F976041F]',
               hoverBgColor: 'hover:bg-[#F9760440]'
            }
         },
         slaFieldTheme: {
            skeletonBaseColor: '#00000010',
            skeletonHighlightColor: '#00000019',
            verticalLineColor: 'bg-gray-400',
            dangerTheme: {
               iconColor: colors['error-600'],
               textColor: '!text-error-600',
               hoverBgColor: 'hover:bg-[#D92D2030]'
            },
            normalTheme: {
               iconColor: colors['gray-700'],
               textColor: '!text-gray-700',
               hoverBgColor: 'hover:bg-[#00000025]'
            },
            warningTheme: {
               iconColor: colors['warning-600'],
               textColor: '!text-warning-600',
               hoverBgColor: 'hover:bg-[#F9760440]'
            }
         }
      },
      documentVerificationUsers: {
         defaultTextColor: 'text-gray-900',
         defaultBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         defaultDescriptionColor: 'text-gray-700',
         userDetailLabelTextColor: 'text-gray-600',
         primaryIconColor: colors['primary-600'],
         defaultHoverBgColor: 'hover:bg-gray-50',
         focusedBgColor: 'bg-gray-50',
         secondaryBgCOlor: 'bg-gray-300'
      },
      connectionStatusAlert: {
         bgColor: 'bg-error-100',
         textColor: 'text-error-700',
         iconColor: colors['error-700']
      },
      iconColors: {
         successVariantColor: colors['success-600'],
         errorVariantColor: colors['error-600'],
         defaultIconColor: colors['gray-600']
      },
      discardedTaskCard: {
         cardColors: 'bg-orange-dark-50 border-orange-dark-300',
         textColor: 'text-warning-700',
         iconColor: colors['warning-700']
      },
      toolTip: {
         bgColor: 'bg-gray-900',
         textColor: 'text-base-white'
      }
   },
   dark: {}
}
